package devxertech.com.pages.career.careerOpenings

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaLocationDot
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.Palette
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CareerOpenings(breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()
    val isJobOpening by remember { mutableStateOf(true) }
    val ctx = rememberPageContext()

    Column(modifier = Modifier.fillMaxWidth()) {
        Box(
            modifier = Modifier.fillMaxWidth()
                .height(
                    when {
                        breakpoint >= Breakpoint.LG -> 100.percent
                        breakpoint > Breakpoint.MD -> 550.px
                        else -> 100.percent
                    }
                )
                .backgroundColor(sitePalette.careerPage.rgb),
            contentAlignment = Alignment.TopCenter
        ) {
            Column(
                modifier = Modifier.fillMaxWidth().padding(top = 30.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    text = "careers at Devxer",
                    modifier = Modifier
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(if (breakpoint < Breakpoint.MD) 15.px else 18.px)
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontWeight(FontWeight.Medium)
                        .lineHeight(15.4.px)
                        .textTransform(TextTransform.Uppercase)
                        .padding(bottom = 10.px)
                )
                Column(horizontalAlignment = Alignment.CenterHorizontally) {
                    val rowTextModifier = Modifier
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 20.px)
                        .fontWeight(FontWeight.ExtraBold)
                        .textTransform(TextTransform.Uppercase)
                    Row(
                        modifier = Modifier.flexWrap(FlexWrap.Wrap),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        if (isJobOpening) {
                            SpanText(
                                text = "Our Current",
                                modifier = rowTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                            )
                            SpanText(
                                text = " Openings",
                                modifier = rowTextModifier.color(sitePalette.primary.rgb)
                            )
                        } else {
                            SpanText(
                                text = "There is",
                                modifier = rowTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                            )
                            SpanText(
                                text = " No Job",
                                modifier = rowTextModifier.color(sitePalette.primary.rgb)
                            )
                            SpanText(
                                text = " Opening Yet!",
                                modifier = rowTextModifier.color(sitePalette.commonSecondaryButtonColor.rgb)
                            )
                        }
                    }
                }
                if (isJobOpening) {
                    Row(
                        modifier = Modifier.fillMaxWidth()
                            .margin(topBottom = 20.px)
                            .gap(30.px)
                            .padding(leftRight = 5.percent)
                            .flexWrap(FlexWrap.Wrap),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        CareerJobs(
                            title = "Lead Generation Expert",
                            onClick = { })
                        CareerJobs(
                            title = "HR Intern",
                            onClick = {
                                ctx.router.navigateTo("Hr-Intern")
                            })
                        CareerJobs(
                            title = "Project Manager",
                            onClick = { })
                        CareerJobs(
                            title = "Senior Full Stack Developer",
                            onClick = { })
                        CareerJobs(
                            title = "SEO Expert",
                            onClick = { })
                        CareerJobs(
                            title = "Ui/Ux Designer",
                            onClick = { })


                    }
                } else {
                    Box(
                        modifier = Modifier.fillMaxWidth().padding(top = 20.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Image(
                            src = Res.Image.career_empty,
                            modifier = Modifier.width(309.px),
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun CareerJobs(
     onClick: () -> Unit,
    title: String,
) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()

        Column (
            modifier = Modifier
                .width(if(window.screen.width >= 1440) 21.percent
                else if(window.screen.width in 1000 .. 1439) 29.percent
                else if (window.screen.width in 426 .. 999) 44.percent
                else 100.percent)
                .height(130.px)
                .padding(20.px)
                .margin(left = 10.px)
                .borderLeft(style = LineStyle.Solid, width = 5.px, color = Palette.HeaderGradientTwo.rgbLight)
                .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
                .borderRadius(8.px)
                .boxShadow(blurRadius = 9.px, offsetY = 1.px, color = Palette.CareerBoxShadow.rgbLight),
        ) {
                FieldTitleTextNormalSimple(
                    text = title,
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    letterSpacing = 0.3.px,
                    fontSize = 15.px,
                    textAlign = TextAlign.Left,
                    fontWeight = 600,
                    whiteSpace = WhiteSpace.PreWrap,
                    marginBottom = 8.px,
                    width = 100.percent
                )
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Start
                ) {
                    FaLocationDot(
                        modifier = Modifier
                            .color(Colors.Black)
                            .margin(right = 5.px),
                        size = IconSize.XS
                    )
                    FieldTitleTextNormalSimple(
                        text = "Lahore,Pakistan",
                        color = sitePalette.commonSecondaryButtonColor.rgb,
                        fontFamily = Constants.ROBOTO_FONT,
                        letterSpacing = 0.3.px,
                        fontSize = 12.px,
                    )
                }
            Spacer()
                    SpanText(
                        text = "View Details",
                        modifier = Modifier.fillMaxWidth()
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(12.px)
                            .color(sitePalette.primary.rgb)
                            .cursor(Cursor.Pointer)
                            .textAlign(TextAlign.End)
                            .textDecorationLine(TextDecorationLine.Underline)
                            .onClick { onClick() }

                    )
                }
            }









